import { Component, OnInit, ViewChild } from '@angular/core';
import { FirebaseService } from 'src/app/services/firebase.service';
import { AngularFireStorage } from '@angular/fire/storage';
import { Router } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';


export class Orders{
pname:string;
speed:string;
total:number;
  constructor(pname, speed, total){
    this.pname = pname;
    this.speed = speed;
    this.total = total;
  }
}

@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.css']
})
export class OrdersComponent implements OnInit {

  displayedColumns: string[] = ['pname', 'total'];
  dataSource : MatTableDataSource<any[]>;


  orders: Orders[] = [];
  order:Orders;

  constructor(private fs:FirebaseService, private afs:AngularFireStorage, private router: Router) {
    let user = JSON.parse(localStorage.getItem('user'));
    if(user){
      this.fs.userOrders(user.uid).subscribe(res =>{
        for( let i in res){
          let data = res[i].payload.doc.data();
          this.fs.getPlan(data['pid']).subscribe(plan =>{
            let pl= plan.payload.data();
            let pname = pl['pname'];
            let speed = pl['speed'];
            let price = pl['price'];
            this.order = new Orders(pname, speed, price);
            this.orders.push(this.order)
            console.log(this.order);
            console.log(this.orders);
          });
        }
      });
    }
    // this.fs.getUsers().subscribe( res => {
    //   this.dataSource=new MatTableDataSource<any>(res);
    //   this.dataSource.paginator = this.paginator;
    // });
   }

  ngOnInit(): void {
  }

  goHome(){
    this.router.navigateByUrl('');
  }

}
